<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import Button from "@/common/Button.vue"
import {useRoute, useRouter} from "vue-router"

const props = defineProps({
    tableName: {
        type: String,
        required: true
    }
})

const route = useRoute()
const router = useRouter()

const componentsStore = useComponentsStore()
const userStore = useUserStore()

// --- Computed ---

const component = computed(() => {
    return componentsStore.items.find(o => o.tableName === props.tableName)
})

const user = computed(() => userStore.user)

const show = computed(() => {
    if (!user.value) return false

    // Administrator can always see it
    if (user.value.administrator) {
        return true
    }

    // Otherwise, check for form admin access and if the component belongs to the "Forms" group
    return (
        user.value.access?.__formAdmin &&
        component.value?.navigationGroup === 'Forms'
    )
})

// --- Methods ---

const goToComponentSettings = () => {
    // Use the component name from the current route parameters
    const tableNameParam = route.params.component
    router.push({
        name: 'componentSettings',
        params: {component: tableNameParam}
    })
}
</script>

<template>
    <Button v-if="show" @click="goToComponentSettings">
        <i class="bi-gear-fill me-2"/>
        Settings
    </Button>
</template>